export default __webpack_public_path__ + "static/media/DOM-MAR2025.de32b16f.png";